import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/Auth/login",
    method: "post",
    data,
  });
}

export function refreshToken(refreshToken) {
  return request({
    url: "/auth/refresh-token",
    method: "post",
    data: { refreshtoken: refreshToken },
    skipAuthRefresh: true,
  });
}

export function revokeToken(refreshToken) {
  return request({
    url: "/Auth/revoke",
    method: "post",
    data: { refreshtoken: refreshToken },
    skipAuthRefresh: false,
  });
}

export function logout() {
  return request({
    url: "/Auth/logout",
    method: "post",
  });
}

export function getUserProfile() {
  return request({
    url: "/users/profile",
    method: "get",
  });
}

export function getUserRoles() {
  return request({
    url: "/auth/getroles",
    method: "get",
  });
}
// export function getRemoteUser(data) {
//   return request({
//     url: "/users/get-remote-user",
//     method: "get",
//     params: data,
//   });
// }
// export function getUserData(data) {
//   return request({
//     url: "/users/get-user-details",
//     method: "get",
//     params: data,
//   });
// }
// export function updateUser(data) {
//   return request({
//     url: "/users/edit-user",
//     method: "put",
//     data,
//   });
// }

// export function addNewUser(data) {
//   return request({
//     url: "/users/create-new-user",
//     method: "post",
//     data,
//   });
// }
// export function deleteUser(id) {
//   return request({
//     url: `/users/delete-user?id=${id}`,
//     method: "post",
//   });
// }

// export function getUsersList(data) {
//   return request({
//     url: "/users/search",
//     method: "post",
//     data,
//   });
// }
// export function toggleActiveUser(data) {
//   return request({
//     url: "/users/change-activation-status",
//     method: "post",
//     data,
//   });
// }
// export function autoCompleteUsersForConsultions(data) {
//   return request({
//     url: "/users/auto-complete-consultations-users",
//     method: "post",
//     data,
//   });
// }
// export function getPermissions({ userID, data }) {
//   return request({
//     url: `/users/${userID}/permissions`,
//     method: "get",
//     data,
//   });
// }
// export function SavePermissions(data) {
//   return request({
//     url: `/users/assign-conferences`,
//     method: "post",
//     data,
//   });
// }
// export function getUserPermission(userId) {
//   return request({
//     url: `/users/${userId}/permissions`,
//     method: "get",
//   });
// }

// export function editUserPermissions(data) {
//   return request({
//     url: `/users/edit-user-permissions`,
//     method: "post",
//     data,
//   });
// }
// export function personInfo(data) {
//   return request({
//     url: `/users/get-person-info`,
//     method: "get",
//     params: data,
//   });
// }

// Activate/reset user (operationType: 1=Reset Password, 2=Activate user, 3=New email)
export function UserOperation({ operationType, activationId, pass }) {
  if (!operationType || !activationId) {
    return Promise.reject(new Error("Invalid parameters"));
  }
  if((operationType === 1 || operationType === 2) && !pass){
    return Promise.reject(new Error('password is required for this operation type'))
  }
  const params = new URLSearchParams({
    operationType: String(operationType),
    activationId: activationId,
  });
  const data = {};
  if (operationType === 1 || operationType === 2) {
    data.password = pass;
  }
  return request({
    url: `/auth/activate?${params.toString()}`,
    method: "post",
    data,
  });
}

export function sendForgotPasswordEmail(email) {
  if (!email || typeof email !== "string" || !email.trim()) {
    return Promise.reject(new Error("A valid email address is required."));
  }
  return request({
    url: `/auth/reset-request`,
    method: "get",
    params:{
      email
    }
  });
}
